export enum REQUEST_TITLE {
    NEW_REQUESTS = 'newRequests',
    RETURNED_REQUESTS = 'returnedRequests',
    ASSIGNED_TO_ME_REQUESTS = 'requestsAssignedToMe',
    INPROGRESS_REQUESTS = 'requestsInProgress',
    SECURITY_COORDINATOR_REQUESTS = 'securityCoordinatorRequests',
    EMPLOYEE_MANAGEMENT_REQUESTS = 'employeeManagementRequests',
    COMPLETED_REQUESTS = 'completedRequests',
    TO_COMPLETED_REQUESTS = 'tocompletedRequests',
    DASHBOARD = 'dashboard',
    COMPLETED_HISTORY_REQUESTS = 'completedHistoryRequests',
    TECHNICAL_OPERATIONS_REQUESTS = 'technicalOperationsRequests',
    CALL_RECORD = 'callRecord',
    CALL_RECORD_DASHBOARD = 'callRecordDashboard',

}
